/**
 * 判断这个用户id是否未客服
 * id >= 99999999 为客服id
 * @param val
 * @returns
 */
export const isKefuId = (id: number): boolean => {
  return !!(id >= 99999999)
}
